import globals from "imports/globals";
import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        function isNavLink(_el) {
            return $(_el).parents("#nav").length;
        }

        function menuOpenHandler() {
            $("html").addClass("menu-visible overlay-visible");
        }

        function menuCloseHandler() {
            $("html").removeClass("menu-visible overlay-visible");
        }

        /*
        $(".burger").on("click", function () {
            if ($("html").hasClass("menu-visible")) {
                menuCloseHandler();
            } else {
                menuOpenHandler();
            }
        });
        */

        $(window).on("menuOpen", menuOpenHandler);
        $(window).on("menuClose", menuCloseHandler);

        $("#nav a").on("click", function (e) {
            if ($(e.target).hasClass("site-tagline")) {
                e.preventDefault();
                window.scrollTo(0, 0);
                history.pushState("", document.title, window.location.pathname + window.location.search);
            }
            menuCloseHandler();
        });
    });
})();

export default component;
